<template>
  <div class="progress_item" ref="progressItem"
    v-loading="isLoading" element-loading-text="上传中..." element-loading-spinner="el-icon-loading"
    v-show="!(!isPractise && display == 'showAnser')">
    <div class="progress_id">绑定题目ID: <el-input class="display_input" v-model="_progressItem.bindId" size="small"
        @blur="validateNameIptAndSave">
      </el-input>
      <!--添加环节-->
      <el-dropdown class="link_add" @command="linkCommand">
        <el-button size="small" plain>
          <div>
            <img src="@/assets/images/icon-add-link.png" />
            <p>添加环节</p>
          </div>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="link_add_dropdown">
          <el-dropdown-item command="1">
            <el-upload class="upload-video" :action="uploadAudioUrl" :show-file-list="false"
              :before-upload="beforeUploadAudio" :on-success="handleAudioSuccess" :on-error="handleAudioError" :headers="customHeaders">
              <el-button size="small" icon="el-icon-video-play" plain class="upload_btn">音频</el-button>
            </el-upload>
          </el-dropdown-item>
          <el-dropdown-item command="2" icon="el-icon-date">
            显示
          </el-dropdown-item>
          <el-dropdown-item command="3" icon="el-icon-edit">
            输入
          </el-dropdown-item>
          <el-dropdown-item command="4" icon="el-icon-video-pause">
            录音
          </el-dropdown-item>
          <el-dropdown-item command="5" icon="el-icon-document-checked" v-show="isPractise">
            答案
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="progress_item_head">
      <!--流程名称-->
      <el-input class="name_ipt" ref="nameIpt" placeholder="输入流程名称" v-model="_progressItem.name" maxlength=7
        :style="{ width: spanWidth }" @blur="validateNameIptAndSave">
      </el-input>
      <!--流程时长-->
      <img class="timer" :src="timePath" />
      <el-input class="time_ipt" placeholder="00:00" v-model="_progressItem.time" maxlength=5 :disabled="timeDisabled"
        @blur="validateTimeIptAndSave">
      </el-input>


    </div>
    <!--添加音频环节-->
    <div class="progress_item_audio" v-if="audioVisible">
      <span>音频:</span>
      <div class="audio_item" style="width:150rem">
        <img src="@/assets/images/icon-audio.png" />
        <span class="audio_name">{{ this._progressItem.audioDuration ? this._progressItem.audioDuration : '00:00' }}&nbsp;&nbsp;
          <el-tooltip class="item" effect="light" :content="_progressItem.audioName" placement="top">
            <span>{{this._progressItem.audioName}}</span>
          </el-tooltip>
        </span>
      </div>
      <el-upload class="upload-video" :action="uploadAudioUrl" :show-file-list="false"
        :before-upload="beforeUploadAudio" :on-success="handleAudioSuccess" :on-error="handleAudioError"
        :headers="customHeaders"
        >
        <!-- <el-button size="small" plain class="upload_btn">替换</el-button> -->
      </el-upload>
      <p @click="deleteAudio">删除</p>

      <el-dropdown class="play_times" @command="playCommand">
        <el-button plain>
          播放<span style="color:#FFB802;">{{ this._progressItem.playTimes }}</span>次<i
            class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="play_times_dropdown">
          <el-dropdown-item command="1">1次</el-dropdown-item>
          <el-dropdown-item command="2">2次</el-dropdown-item>
          <el-dropdown-item command="3">3次</el-dropdown-item>
          <el-dropdown-item command="4">4次</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown class="play_setting" @command="setCommand">
        <el-button plain>
          设置<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="play_setting_dropdown">
          <el-dropdown-item command="1">详情</el-dropdown-item>
          <el-dropdown-item command="2">下载</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--添加录音环节-->
    <div class="progress_item_show" v-if="display == 'showRecord'">
      <div>录音环节</div>
      <div class="del_diy" @click="clearDisplay">删除</div>
    </div>
    <!--添加显示环节-->
    <div class="progress_item_show" v-if="display == 'showAnser'">
      <div>答案材料展示</div>
      <div class="del_diy" @click="clearDisplay">删除</div>
    </div>
    <!--添加显示环节-->
    <div class="progress_item_show" v-if="displayVisible">
      <div class="showLeft">显示:</div>
      <div class="showRight">
        <el-input class='display_input' ref='displayInput' placeholder="内容ID" v-model="item.content" maxlength=10
          v-for="(item, index) in _progressItem.displays" @input="inputChange(item)" :key="index" @focus="focusIpt($event)"
          @blur="blurIpt($event, item, index)">
          <template #suffix>
            <i class="el-icon-error" @click="handleClick(index, 1)"></i>
          </template>
        </el-input>
        <img src="@/assets/images/icon-addSelect.png" style="cursor:pointer" @click="addDisplayIpt" />
      </div>

    </div>
    <!--添加输入环节-->
    <div class="progress_item_input" v-if="inputVisible">
      <div class="input_left">输入:</div>
      <div class="input_right">
        <el-input placeholder="点击输入" v-model="item.content" maxlength=10 v-for="(item, index) in _progressItem.inputs"
          :key="item.id" @focus="inputFocus($event)" @blur="inputBlur($event)">
          <template slot="prepend">
            <div class="input_prepend" ref='inputPrepend' placeholder=""
              @blur="prependBlur($event, item)" @keydown="handleKeyDown" @input="prependInput">
              {{item.number}}
            </div>
          </template>
          <template slot="suffix">
            <i class="el-icon-error" @click="handleClick(index, 2)"></i>
          </template>
        </el-input>
        <img src="@/assets/images/icon-addSelect.png" style="cursor:pointer" @click="addInput" />
      </div>
    </div>
    <!--操作环节-->
    <div class="progress_item_option" v-if="optionVisible && isPractise && optionNotEmpty">
      <div class="operation">操作:</div>
      <div class="operation_right">
        <el-checkbox-group v-model="_progressItem.options" @change="validateNameIptAndSave">
          <el-checkbox v-for="(item, index) in modeOptions" :key="index" :label="item">{{ item }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!--跳转-->
    <!-- <div class="progress_item_option jump_step"
            v-if="(_progressItem.options.includes('上一小题') || _progressItem.options.includes('下一小题'))&&isPractise">
            <div class="skip">跳转:</div>
            <div class="progress_step">
                <div v-if="_progressItem.options.includes('上一小题')">上一小题跳转至
                    <el-select v-model="_progressItem.preStep" placeholder="请选择" size="mini">
                        <el-option v-for="item in processOption" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="_progressItem.options.includes('下一小题')">下一小题跳转至
                    <el-select v-model="_progressItem.nextStep" placeholder="请选择" size="mini">
                        <el-option v-for="item in processOption" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div> -->
    <!--音频详情-->
    <el-dialog title="音频详情" :visible.sync="dialogVisible">
      <p>音频名称: {{ this._progressItem.audioName }}</p>
      <p>音频时长: {{ this._progressItem.audioDuration }}</p>
      <p>音频格式: {{ this._progressItem.audioFormat }}</p>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from "@/utils/event-bus.js";
import { uploadAudio } from "@/constants/constants";
// import { getModeSetting } from "@/api/answeringProcess";
import { getToken } from '@/utils/auth';
import { getModuleType } from "@/utils/util.js";
export default {
  props: {
    progressItem: {
      type: Object,
      default: function () {
        return {}
      }
    },
    nowLabel: {
      type: String,
      default: ''
    },
    nowLabelId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    processOption: {
      type: Array
    },
    processId: {
      type: String
    },
    isPractise: {
      type: Boolean,
      default: true,
    },
    options:{
      type: Array,
      default: () => []
    },
    optionNotEmpty:  {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    options:{
      handler(newVal){
        this.modeOptions = newVal
      },
      deep: true,
      immediate: true
    },
    progressItem: {
      handler(newVal) {
        //监听显示的栏位,时间输入框使能
        if (newVal.audioUrl) {
          this.audioVisible = true
          this.timeDisabled = true
        } else {
          this.audioVisible = false
          this.timeDisabled = false
        }
        //显示输入框没有不显示
        if (newVal.displays.length > 0) {
          this.displayVisible = true
        } else {
          this.displayVisible = false
        }
        //输入内容校验
        if (newVal.inputs.length > 0) {
          this.inputVisible = true
        } else {
          this.inputVisible = false
        }
        //监听时钟图标
        if (newVal.time) {
          this.timePath = require("@/assets/images/icon-timer-init-active.png")
        } else {
          this.timePath = require("@/assets/images/icon-timer-init.png")
        }
        this.display = newVal.display;

      },
      deep: true,
      immediate: true
    },
    fieldsJSON: {
      handler(newVal, oldVal) {
        console.log('fieldsJSONnewValnewValnewVal', newVal,oldVal)
        //fieldsJSON改变对比_progressItems中数据 添加防抖
        // this.debounce(this.compareWithProgress(newVal, oldVal), 500)

      },
      deep: true,
      // immediate:true
    },

  },
  computed: {
    _progressItem: {
      set(newVal) {
        this.$emit('update:progressItem', newVal)
      },
      get() {
        return this.progressItem
      }
    },
    fieldsJSON() {
      //解决监听新旧值一样的问题
      return JSON.parse(JSON.stringify(this.$store.state.fieldsJSON))
    },
    regionId() {
      return this.$store.state.regionId
    },
    bookId() {
      return this.$store.state.bookId
    },
    catalogType() {
      return this.$store.state.catalogType
    },
  },
  mounted() {
    // setTimeout(()=>{
    //   console.log(this.optionVisible);
    //   console.log(this.isPractise);
    //   console.log(this.optionNotEmpty);
    // },2000)
    EventBus.$on('updateProgressItem', this.updateProgressItem)
    //初始化流程新建操作选项 为options赋值
    // this.refreshModeSetting(false)

    //输入环节头部刷新placeholder
    document.querySelectorAll('.input_prepend').forEach(element => {
      let text = element.innerHTML.trim()
      if (text == ''){
        element.innerHTML = ''
      }
    })
    
  },

  beforeDestroy() {
    EventBus.$off('updateProgressItem', this.updateProgressItem)
  },

  data() {
    return {
      customHeaders:{
          'Authorization':getToken()
      },
      spanWidth: '130rem',
      checkList: [],
      modeOptions:[],
      isLoading: false,
      spanText: '序号',
      timeDisabled: false,
      audioVisible: false,
      displayVisible: false,
      dialogVisible: false,
      inputVisible: false,
      optionVisible: true,
      // options: [],  //'上一大题','上一小题', '下一大题', '下一小题', '跳过', '我的回答', '重新回答', '提交'
      timePath: require("@/assets/images/icon-timer-init.png"),
      idIndex: parseInt(new Date().getTime() / 1000),
      preStep: '',
      nextStep: '',
      bindId: '',
      display: '',
      uploadAudioUrl: uploadAudio
    }
  },
  methods: {
    clearDisplay() {
      this._progressItem.display = "";
    },
    //监听数据防抖
    debounce(fn, wait) {
      let timeout = null;
      return function () {
        let context = this;
        let args = arguments;
        if (timeout) clearTimeout(timeout);
        let callNow = !timeout;
        timeout = setTimeout(() => {
          timeout = null;
        }, wait);
        if (callNow) fn.apply(context, args);
      };
    },
    //模式设置变更后及时更新流程中的操作项,默认查最小范围的值
    // refreshModeSetting(flag) {
    //   getModeSetting({ regionId: this.regionId, bookId: this.bookId, catalogType: this.catalogType }).then(res => {
    //     if (res.data && res.data.testOperations) {
    //       let opts = JSON.parse(res.data.testOperations)
    //       if (opts.length > 0) {
    //         this.optionNotEmpty = true
    //       } else {
    //         this.optionNotEmpty = false
    //       }
    //       this.options = opts

    //     } else {
    //       this.options = []
    //       this.optionNotEmpty = false
    //     }
    //     //对比_progressItems中数据
    //     if (flag) {
    //       this.compareWithProgressOps()
    //     }
    //   })
    // }, 
    //初始化流程名称输入框长度
    // setInputWidth() {
    //     if (this._progressItem.name) {
    //         this.spanText = this._progressItem.name
    //         const spanStyle = this.$refs.spanText;
    //         this.$nextTick(() => {
    //             // 如果不用$nextTick的话页面并不会更新，它是在下次dom更新后再渲染到页面上
    //             this.spanWidth = (spanStyle.offsetWidth) + "rem"
    //         });
    //     }
    // },
    //对比_progressItems中数据,如果options删除了某个元素,对应的_progressItem.options也要处理,将_progressItem.options在
    //options中不存在的删除
    compareWithProgressOps() {
      this._progressItem.options = this._progressItem.options.filter(item => this.options.indexOf(item) != -1)
      this.$emit('updateTolist', this.progressItem)
    },
    //fieldsJSON改变对比_progressItems中数据
    //删除,显示失效样式 手动点击删除
    //修改，联动修改对应的标题名称，和栏位id
    compareWithProgress(newVal, oldVal) {
      // EventBus.$emit('updateProgressItem', { newVal, oldVal })
      this.updateProgressItem({ newVal, oldVal })

    },
    //更新所有的试题流程信息
    updateProgressItem(valObj) {
      //删除试题内容
      let targetVal = []
      if (valObj.newVal.length == 0) {
        targetVal = valObj.oldVal
      } else {
        targetVal = valObj.newVal
      }
      let targetArr = []
      //更新显示环节
      targetVal.forEach(i => {
        targetArr.push(i.id)
        this._progressItem.displays.forEach(item => {
          if (item.idx == i.id) {
            item.content = i.type
            item.id = i.fieldId
            // this.$emit('updateTolist', this.progressItem)
          }
        })
      })
      //添加失效样式
      this.$nextTick(()=>{
        this._progressItem.displays.forEach((item, index) => {
          // if ((valObj.newVal.length == 0 && targetArr.includes(item.idx)) || (!targetArr.includes(item.idx) && item.idx)) {
          // console.log(targetArr,targetArr.includes(item.idx))
          if ((valObj.newVal.length == 0 || !targetArr.includes(item.idx))) {
            this.$refs.displayInput[index].$el.classList.add('input_disable')
          }else{
            this.$refs.displayInput[index].$el.classList.remove('input_disable')
          }
        })
      })
    },
    //流程名称校验
    validateNameIptAndSave() {
      EventBus.$emit('contentChangeIdUn',this.$store.state.coilingId) //联动流程那边编辑后试卷的星号
      //及时更新顶级数据列表
      this.$emit('updateTolist', this.progressItem)
      console.log(this.progressItem);
    },
    validateTimeIptAndSave() {
      EventBus.$emit('contentChangeIdUn',this.$store.state.coilingId) //联动流程那边编辑后试卷的星号

      if (this._progressItem.time && (!/^(?:[0-5][0-9]:[0-5][0-9])$/.test(this._progressItem.time))) {
        this.$message.error('时间格式错误,请重新输入!');
        this._progressItem.time = '';
      }

      //及时更新顶级数据列表
      this.$emit('updateTolist', this.progressItem)
    },
    linkCommand(val) {
      if (val === '4') {
        this._progressItem.display = 'showRecord';
        this.$emit('updateTolist', this.progressItem)
      }
      if (val === '5') {
        this._progressItem.display = 'showAnser';
        this.$emit('updateTolist', this.progressItem)
      }
      if (val === '2') {
        // this.idIndex++
        this._progressItem.displays.push(
          {
            id: '',  //栏位id
            content: '', //栏位名称
            idx: '',
          }
        )
        this.$emit('updateTolist', this.progressItem)
      }
      if (val === '3') {
        this.idIndex++
        this._progressItem.inputs.push(
          {
            id: this.idIndex,
            number: '',
            content: ''
          }
        )
        this.$nextTick(() => {
          this.$refs.inputPrepend[this.$refs.inputPrepend.length - 1].focus()
        }
        )
        this.$emit('updateTolist', this.progressItem)
      }
    },
    playCommand(val) {
      this._progressItem.playTimes = val
      this.$emit('updateTolist', this.progressItem)
    },
    setCommand(val) {
      if (val === '1') {
        this.dialogVisible = true
      } else {
        window.location.href = this._progressItem.audioUrl
      }
    },
    deleteAudio() {
      this.$confirm(`是否删除音频?`, "删除提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "customClass",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          this._progressItem.audioUrl = ''
          this._progressItem.audioDuration = ''
          this._progressItem.playTimes = '1'
          this.$emit('updateTolist', this.progressItem)
          //启用时长输入框
          this.timeDisabled = false
          this.$message.success('删除成功!')
        })
        .catch(() => {
          this.$message.error('删除失败!')
        });
    },
    addDisplayIpt() {
      // this.idIndex++
      this._progressItem.displays.push(
        {
          id: '',  //栏位id
          content: '', //栏位名称
          idx: '',  //唯一id
        }
      )
      this.$emit('updateTolist', this.progressItem)
    },
    addInput() {
      if (this._progressItem.inputs.length < 15) {
        this.idIndex++
        this._progressItem.inputs.push(
          {
            id: this.idIndex,
            number: '', //填空题序号
            content: ''//填空题placeholder
          }
        )
        this.$nextTick(() => {
          this.$refs.inputPrepend[this.$refs.inputPrepend.length - 1].focus()

        }
        )
        this.$emit('updateTolist', this.progressItem)
      } else {
        this.$message.error('无法添加更多!')
      }
    },

    //根据输入内容动态改变input宽度
    // getValue(val) {
    //     this.spanText = val;
    //     const spanStyle = this.$refs.spanText
    //     this.$nextTick(() => {
    //         // 如果不用$nextTick的话页面并不会更新，它是在下次dom更新后再渲染到页面上
    //         if (spanStyle.offsetWidth > 30) {
    //             this.spanWidth = (spanStyle.offsetWidth + 30) + "rem"
    //         } else {
    //             this.spanWidth = "120rem"
    //         }
    //     });
    // },
    handleClick(index, type) {
      if (type === 1) {
        //先移除失效样式
        this._progressItem.displays.splice(index, 1)
        // let result = this._progressItem.displays.splice(index, 1)
        this.$forceUpdate()
        // if (result.length > 0) {
        //   // document.querySelectorAll('.display_input')[index].classList.remove('input_disable')
        // }
      }
      if (type === 2) {
        this._progressItem.inputs.splice(index, 1)
      }
      this.$emit('updateTolist', this.progressItem)
      this.updateProgressItem({'newVal':this.$store.state.fieldsJSON})
    },
    focusIpt(e) {
      let deleteDom = e.target.nextElementSibling.children[0].children[0]
      deleteDom.classList.add("el-icon-error-focus")
    },
    inputChange(item){
      console.log(item)
      item.id = ''
      item.idx = ''
    },
    blurIpt(e, item, index) {
      EventBus.$emit('contentChangeIdUn',this.$store.state.coilingId) //联动流程那边编辑后试卷的星号
      //todo 复制id调用接回返回数据
      let arr = []
      if (this.fieldsJSON.length == 0) {
        return
      }
      let flag = false;
      // if (this.type == '听说模拟训练') {
      if (getModuleType(this.type,this) == 1) {
        let idx = -1
        console.log(idx)
        // let count = 0
        this.fieldsJSON.forEach((item, index) => {
          if (item.id == this.nowLabelId) {
            idx = index
          }
        })
        //只获取当前一级题干及子题干信息
        for (let i = 0; i < this.fieldsJSON.length; i++) {
          // if (this.fieldsJSON[i].type == '一级题干') {
          //   count++
          // }
          // if (count > 1) {
          //   break;
          // }
          console.log(this.fieldsJSON[i].fieldId,item.content)
          //显示栏创建的时候，只需要保证栏位id能匹配到就行了
          if (this.fieldsJSON[i].fieldId == item.content) {
            flag = true
            arr.push({
              idx: this.fieldsJSON[i].id,
              id: this.fieldsJSON[i].fieldId,
              content: this.fieldsJSON[i].type,
            })
          }
        }
        //先删除当前复制的输入框再插入
        if (flag) {
          this._progressItem.displays.splice(index, 1)
          this._progressItem.displays.splice(index, 0, ...arr)
        }else{
          // this._progressItem.displays.splice(index, 1)
          // this._progressItem.displays.splice(index, 0, {
          //     idx: "",
          //     id: "",
          //     content: item.content,
          // })
        }

        console.log(this.fieldsJSON,item,arr)

        this.updateProgressItem({'newVal':this.$store.state.fieldsJSON})
      } else if (getModuleType(this.type,this) == 2){//(this.type == '题型专项训练') {
        for (let i = 0; i < this.fieldsJSON.length; i++) {
          if (this.fieldsJSON[i].fieldId == item.content) {
            flag = true
            arr.push({
              idx: this.fieldsJSON[i].id,
              id: this.fieldsJSON[i].fieldId,
              content: this.fieldsJSON[i].type,
            })
          }
        }
        if (flag) {
          this._progressItem.displays.splice(index, 1)
          this._progressItem.displays.splice(index, 0, ...arr)
        }else{
          // this._progressItem.displays.splice(index, 1)
          // this._progressItem.displays.splice(index, 0, {
          //     idx: "",
          //     id: "",
          //     content: item.content,
          // })
        }
        this.updateProgressItem({'newVal':this.$store.state.fieldsJSON})
      }else{
        for (let i = 0; i < this.fieldsJSON.length; i++) {
          if (this.fieldsJSON[i].fieldId == item.content) {
            flag = true
            arr.push({
              idx: this.fieldsJSON[i].id,
              id: this.fieldsJSON[i].fieldId,
              content: this.fieldsJSON[i].type,
            })
          }
        }
        if (flag) {
          this._progressItem.displays.splice(index, 1)
          this._progressItem.displays.splice(index, 0, ...arr)
        }
      }
      this.$emit('updateTolist', this.progressItem)
      setTimeout(() => {
        e.target.nextElementSibling.children[0].children[0].classList.remove("el-icon-error-focus")
      }, 200)
    },
    inputFocus(e) {
      e.target.nextElementSibling.children[0].children[0].classList.add("el-icon-error-focus")
    },
    inputBlur(e) {
      EventBus.$emit('contentChangeIdUn',this.$store.state.coilingId) //联动流程那边编辑后试卷的星号

      this.$emit('updateTolist', this.progressItem)
      setTimeout(() => {
        e.target.nextElementSibling.children[0].children[0].classList.remove("el-icon-error-focus")
      }, 200)
    },

    prependBlur(event, item) {
      EventBus.$emit('contentChangeIdUn',this.$store.state.coilingId) //联动流程那边编辑后试卷的星号
      
      this.$nextTick(() =>{
        item.number = event.target.innerText;
        //加上不然会有渲染bug
        event.target.innerText = item.number
      })
    },

    prependInput(event) {
      if (event.target.innerText.length > 2) {
        event.target.innerText = event.target.innerText.substr(0, 3);
        //等待dom渲染完成
        this.$nextTick(() => {
          event.target.blur()
        })
      }
      this.removeNewLines();
    },
    //禁止换行
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
      this.removeNewLines();
    },
    //清除任何现有的换行
    removeNewLines() {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        range.deleteContents();
        const textNode = document.createTextNode('');
        range.insertNode(textNode);
        selection.collapse(textNode, 0);
      }
    },
    //音频上传前校验
    beforeUploadAudio(file) {
      this.isLoading = true
      const isAudio = file.type === "audio/mp3" || file.type === "audio/mpeg";
      if (!isAudio) {
        this.isLoading = false
        this.$message.error("请上传音频文件!");
      } else {

        this.getTimes(file)
      }
      return isAudio
    },

    handleAudioSuccess(res) {
      this.isLoading = false
      this.$message.success('上传成功!')
      this.showAudio(res)
    },
    handleAudioError() {
      this.isLoading = false
      this.$message.error('上传失败,请检查网络并重新上传!')
    },
    //获取音频时长
    getTimes(file) {
      const content = file;
      const url = URL.createObjectURL(content);
      const audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", () => {
        //音频详情
        this._progressItem.audioName = file.name
        this._progressItem.audioFormat = file.type
        this._progressItem.audioDuration = this.parseTime(parseInt(audioElement.duration))
      });
    },

    //转换成'00:00'分秒显示
    parseTime(scecond) {
      let secondTime = scecond
      let minuteTime = 0;
      if (scecond > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
      }
      secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
      let result = "" + secondTime + "";
      if (minuteTime > 0) {
        //若分钟数是个位数，前面用0补齐
        minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
        result = "" + minuteTime + ":" + result;
      } else {
        //若分钟数为0，用"00"表示
        result = "" + "00" + ":" + result;
      }
      return result;
    },
    //显示音频栏,新建的流程按此方式显示 拉取的数据需要另作判断,  todo
    showAudio(res) {
      console.log("res==>", res)
      this._progressItem.audioUrl = res.data
      this.$emit('updateTolist', this.progressItem)
      this.audioVisible = true
      //禁用时长输入框
      this.timeDisabled = true
      this._progressItem.time = ''
    },

  },

}
</script>

<style lang="scss" scoped>
::v-deep .el-dropdown {
  font-size: 14rem;
}
.progress_item {
  border: 1rem solid #E9E9E9;
  border-radius: 6rem;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 5rem 12rem 15rem 12rem;

  .progress_id {
    font-size: 12rem;
    color: #666666;
    display: flex;
    white-space: nowrap;
    align-items: center;

     ::v-deep .el-input__inner {
      width: 100rem;
      border: none;

    }

    .link_add {
      position: absolute;
      right: 0rem;

      .el-button {
        border: none;
        font-size: 14rem;
        color: var(--primary-color);
        background: transparent;

        img {
          margin-right: 5rem;
        }
      }

      div {
        display: flex;
        align-items: center;
      }


    }
  }

  .progress_item_head {
    display: flex;
    align-items: center;

    .progress_count {
      margin-right: 5rem;
    }

    .name_ipt {
      width: 140rem;
      color: aqua;

      ::v-deep .el-input__inner {
        border: none;
        padding: 0rem;
        height: 1em;
        font-size: 18rem;
        color: #000000;
        background: transparent;
      }
    }

    .spanText {
      font-size: 12rem;
      position: absolute;
      left: 0;
      padding: 0 15rem;
      white-space: nowrap;
      visibility: hidden;
    }

    .timer {
      color: brown;
      transform: scale(0.5, 0.5);
    }

    .time_ipt {
      width: 61rem;
      border-radius: 6rem;

      ::v-deep .el-input__inner {
        height: 24rem;
        padding: 10rem;
        background: transparent;
        font-size: 14rem;
      }

      ::v-deep .el-input__inner:focus,
      ::v-deep .el-input__inner:hover {
        border-color: #E9E9E9;
      }
    }


  }

  .progress_item_audio {
    display: flex;
    align-items: center;
    height: 30rem;
    font-size: 14rem;

    span {
      width: 35rem;
    }
    .audio_name{
      width: 150rem;
      overflow: hidden;/*超出部分隐藏*/
      text-overflow:ellipsis;/* 超出部分显示省略号 */
      white-space: nowrap;/*规定段落中的文本不进行换行 */
    }

    p {
      margin-left: 10rem;
      width: 35rem;
      font-size: 14rem;
      color: #666666;
      cursor: pointer;
    }

    .upload_btn {
      border: none;
      font-size: 14rem;
      color: #666666;
      width: 50rem;
    }

    .audio_item {
      margin-left: 10rem;
      display: flex;
      align-items: center;
      width: 60rem;
      justify-content: space-around;
    }

    .play_times {
      .el-button {
        padding: 2rem;
        margin-left: 4rem;
        width: 80rem;
        border: none;
        // height: 1em;
        color: #666666;
        background: transparent;
        font-size: 14rem;
      }
    }

    .play_setting {
      .el-button {
        padding: 2rem;
        margin-left: 4rem;
        // width: 30rem;
        // height: 1em;
        border: none;
        color: #666666;
        background: transparent;
        font-size: 14rem;
      }
    }
  }

  .progress_item_show {
    display: flex;
    width: 100%;
    font-size: 14rem;

    .del_diy {
      cursor: pointer;
      margin-left: 8rem;
      color: #777;
    }

    .showLeft {
      width: 36rem;
      line-height: 36rem
    }

    .showRight {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      flex: 1;

      .el-input {
        width: 85rem;
        border-radius: 6rem;
        padding-left: 10rem;
        margin: 6rem 0rem 6rem 0rem;

        ::v-deep .el-input__inner {
          height: 24rem;
          background: transparent;
        }

        ::v-deep .el-input__inner:focus,
        ::v-deep .el-input__inner:hover {
          border-color: #FFB802;
        }

        .el-icon-error {
          color: #FF0000;
          position: absolute;
          cursor: pointer;
          top: -4rem;
          right: -10rem;
          width: 16rem;
          height: 16rem;
          display: none;
        }

        .el-icon-error-focus {
          display: block;
        }
      }

      img {
        transform: scale(0.5, 0.5);
        // margin-bottom: 10rem;
      }
    }

    ::v-deep .el-input--suffix .el-input__inner {
      padding-right: 5rem;
      padding-left: 5rem;
    }


  }

  .progress_item_input {
    font-size: 14rem;
    display: flex;

    .input_left {
      width: 36rem;
      line-height: 36rem
    }

    .input_right {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      margin-top: 4rem;

      .el-input {
        width: 106rem;
        // margin-bottom: 4rem;
        margin-left: 10rem;
        position: relative;

        ::v-deep .el-input__inner {
          margin-left: 30rem;
          width: 74rem;
          height: 24rem;
        }

        ::v-deep .el-input__inner:focus,
        ::v-deep .el-input__inner:hover {
          border-color: #FFB802;
        }

        .el-icon-error {
          color: #FF0000;
          position: absolute;
          cursor: pointer;
          top: -4rem;
          right: -10rem;
          width: 16rem;
          height: 16rem;
          display: none;
        }

        .el-icon-error-focus {
          display: block;
        }

        ::v-deep .el-input-group__prepend {
          position: absolute;
          top: -1rem;
          padding: 0rem;
          width: 32rem;
          height: 24rem;
          text-align: center;
          background: #FFB802;
          color: #FFFFFF;
        }
      }

      .input_prepend {

        display: inline-block;
        line-height: 24rem;
      }

      .input_prepend:empty:before {
        content: attr(placeholder);
        color: #fff;
      }

      [contenteditable]:focus {
        outline: none;
      }

      ::v-deep .el-input--suffix .el-input__inner {
        padding-right: 0rem;
      }

      ::v-deep .el-input--suffix .el-input__inner {
        padding-right: 5rem;
        padding-left: 5rem;
      }

      .el-input:nth-child(n) {
        margin: 3rem 0rem 3rem 10rem;
      }

      img {
        transform: scale(0.5, 0.5);
      }
    }
  }

  .progress_item_option {
    margin-top: 5rem;
    font-size: 14rem;
    display: flex;

    .operation {
      width: 50rem;
      line-height: 24px
    }

    .operation_right {
      width: 100%
    }

    .skip {
      width: 45rem;
      line-height: 24rem
    }

    .el-checkbox-group {
      display: inline;

      .el-checkbox {
        width: 13%;

      }
    }

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #FFB802;
      border-color: #FFB802;
    }

    ::v-deep .el-checkbox__input .el-checkbox__inner:hover,
    ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #FFB802;
    }

    ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #303133;
    }

    ::v-deep .el-checkbox__label {
      color: #A8ABB2;
      font-size: 14rem;
    }

  }

  .jump_step {
    line-height: 28rem;

    .progress_step {
      display: flex;

      ::v-deep.el-select {
        margin-left: 5rem;
        width: 80rem;

        .el-input__suffix {
          display: none;
        }

        .el-input__inner {
          border: none;
        }
      }


    }
  }



  ::v-deep .el-dialog {
    border-radius: 10rem;
    width: 400rem;
    // height: 200rem;
    background: #F5F5F5;

    p {
      font-size: 14rem;

      margin-bottom: 20rem;
    }

  }

  ::v-deep .el-dialog__body {
    // padding: 0rem;
    padding-top: 10rem;
    padding-left: 30rem;
    // margin: 0rem;
  }

  ::v-deep .el-dialog__title {
    padding-left: 10rem;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 5rem;
      height: 20rem;
      border-radius: 10rem;
      background-color: var(--primary-color);
    }

  }

  ::v-deep .el-dialog__header .el-dialog__close:hover {
    color: var(--primary-color) !important;
  }
}

.link_add_dropdown {
  .el-dropdown-menu__item {
    width: 56rem;
  }
}

.play_times_dropdown .el-dropdown-menu__item,
.play_setting_dropdown .el-dropdown-menu__item {
  width: 30rem;
}


.el-dropdown-menu__item {
  font-size: 14rem;
  // height: 35rem;
  position: relative;
  overflow: hidden;

  // width: 60rem;
  .upload_btn {
    position: absolute;
    top: 0rem;
    left: -3rem;
    width: 100%;
    background: transparent;
    border: none;
    font-size: 14rem;
  }

  .upload_btn:hover {
    color: var(--primary-color);
    background-color: #d5fae0;
  }
}

.el-dropdown-menu__item:hover {
  color: var(--primary-color);
  background-color: #d5fae0;
}

::v-deep .el-loading-spinner .el-icon-loading,
::v-deep .el-loading-spinner .el-loading-text {
  color: var(--primary-color);
}

.input_disable {

  // 输入框失效样式
  ::v-deep .el-input__inner {
    border-color: #FF0000;
    color: #FF0000;
    background: #F7E8E8;
  }

  ::v-deep .el-input__inner::placeholder {
    color: #FF0000;
  }

  &::after {
    content: '\5df2\5931\6548';
    color: #FF0000;
    font-size: 10rem;
    position: absolute;
    left: 10rem;
    top: 22rem;
  }
}

.el-icon-error {
  color: #FF0000;
  position: absolute;
  cursor: pointer;
  top: -4rem;
  right: -10rem;
  width: 14rem;
  height: 14rem;
  z-index: 10;
  border-radius: 7rem;
}
</style>